"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.finalizeError = exports.finalizeStatus = exports.setMetadata = exports.setContent = void 0;
exports.timeOrderCommentsInPlace = timeOrderCommentsInPlace;
exports.messageIsCopilotError = messageIsCopilotError;
exports.messageIsCopilotBlocked = messageIsCopilotBlocked;
exports.messageIsDocBrownError = messageIsDocBrownError;
exports.messageIsMutableCopilotStatus = messageIsMutableCopilotStatus;
exports.messageIsProcessingCopilotStatus = messageIsProcessingCopilotStatus;
exports.messageIsFinalCopilotStatus = messageIsFinalCopilotStatus;
exports.messageIsCopilotMessage = messageIsCopilotMessage;
exports.copilotMetadataFromMessage = copilotMetadataFromMessage;
/*
 * Order comments from earliest to latest in-place.
 */
const credit_1 = require("../credit");
const structure_1 = require("./structure");
function timeOrderCommentsInPlace(comments) {
    comments.sort((a, b) => {
        if (a === b)
            return 0;
        return Math.sign(a.created_at - b.created_at);
    });
}
/**
 * Predicate that tells us that the message in question is a copilot error.  Useful for ignoring these messages
 * in subsequent evaluations.
 */
function messageIsCopilotError(message) {
    return message.type === structure_1.MessageType.copilotError;
}
/**
 * Predicate that tells us that the message in question is a copilot blocked message.  Useful for ignoring these messages
 * in subsequent evaluations, and getting more specific metadata
 */
function messageIsCopilotBlocked(message) {
    return message.type === structure_1.MessageType.copilotBlocked;
}
/**
 * Predicate that tells us that the message in question is a doc brown error.  Useful for ignoring these messages
 * in subsequent evaluations.
 */
function messageIsDocBrownError(message) {
    return message.type === structure_1.MessageType.docBrownError;
}
/**
 * Predicate that tells us that the message in question is a mutable copilot status message.  Useful for ignoring these messages
 */
function messageIsMutableCopilotStatus(message) {
    return message.type === structure_1.MessageType.mutableCopilotStatus;
}
function messageIsProcessingCopilotStatus(message) {
    return message.type === structure_1.MessageType.processingCopilotStatus;
}
function messageIsFinalCopilotStatus(message) {
    return message.type === structure_1.MessageType.finalCopilotStatus;
}
function messageIsCopilotMessage(message) {
    return (messageIsFinalCopilotStatus(message) ||
        messageIsMutableCopilotStatus(message) ||
        messageIsCopilotError(message) ||
        messageIsCopilotBlocked(message));
}
/**
 * Provides a backward-compatible read of the copilot metadata from a message
 *
 * Always reads the newest version of the metadata, upgrading older versions as needed
 */
function copilotMetadataFromMessage(message) {
    if (!messageIsCopilotMessage(message)) {
        return undefined;
    }
    return message?.copilotMetadata
        ? {
            ...message?.copilotMetadata,
            respondedTo: message?.copilotMetadata?.respondedTo ?? undefined,
            totalCreditsUsed: message?.copilotMetadata?.totalCreditsUsed ?? 0,
            creditAccountUid: message?.copilotMetadata?.creditAccountUid,
            creditAccountHadLowBalance: message?.copilotMetadata?.creditAccountHadLowBalance ?? false,
            creditPeriod: message?.copilotMetadata?.creditPeriod ?? (0, credit_1.previousCreditPeriod)("flux"),
        }
        : undefined;
}
function convertMessage(message, newType) {
    return {
        ...message,
        type: newType,
    };
}
const setContent = (content) => (message) => {
    message.content = content;
    return message;
};
exports.setContent = setContent;
const setMetadata = (metadata) => (message) => {
    message.copilotMetadata = metadata;
    return message;
};
exports.setMetadata = setMetadata;
const finalizeStatus = (message) => convertMessage(message, structure_1.MessageType.finalCopilotStatus);
exports.finalizeStatus = finalizeStatus;
const finalizeError = (message) => convertMessage(message, structure_1.MessageType.copilotError);
exports.finalizeError = finalizeError;
//# sourceMappingURL=functions.js.map